"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoolTectonicCoreFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_borrowAmount",
                type: "uint256",
            },
        ],
        name: "borrowAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address[]",
                name: "_tTokens",
                type: "address[]",
            },
        ],
        name: "enterMarkets",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
        ],
        name: "exitMarket",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getAccountLiquidity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "isTectonicCore",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tTokenBorrowed",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tTokenCollateral",
                type: "address",
            },
            {
                internalType: "address",
                name: "_liquidator",
                type: "address",
            },
            {
                internalType: "address",
                name: "_borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_repayAmount",
                type: "uint256",
            },
        ],
        name: "liquidateBorrowAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_tTokenBorrowed",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tTokenCollateral",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_repayAmount",
                type: "uint256",
            },
        ],
        name: "liquidateCalculateSeizeTokens",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_mintAmount",
                type: "uint256",
            },
        ],
        name: "mintAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_redeemer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_redeemTokens",
                type: "uint256",
            },
        ],
        name: "redeemAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_redeemer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_redeemAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_redeemTokens",
                type: "uint256",
            },
        ],
        name: "redeemVerify",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_payer",
                type: "address",
            },
            {
                internalType: "address",
                name: "_borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_repayAmount",
                type: "uint256",
            },
        ],
        name: "repayBorrowAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tTokenCollateral",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tTokenBorrowed",
                type: "address",
            },
            {
                internalType: "address",
                name: "_borrower",
                type: "address",
            },
            {
                internalType: "address",
                name: "_liquidator",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_seizeTokens",
                type: "uint256",
            },
        ],
        name: "seizeAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "allowBorrow_",
                type: "bool",
            },
        ],
        name: "setBorrowAllowed",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "seizeTokens_",
                type: "uint256",
            },
        ],
        name: "setCalculatedSeizeTokens",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "shouldFail",
                type: "bool",
            },
        ],
        name: "setFailCalculateSeizeTokens",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "allowLiquidateBorrow_",
                type: "bool",
            },
        ],
        name: "setLiquidateBorrowAllowed",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "allowMint_",
                type: "bool",
            },
        ],
        name: "setMintAllowed",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "allowRedeem_",
                type: "bool",
            },
        ],
        name: "setRedeemAllowed",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "verifyRedeem_",
                type: "bool",
            },
        ],
        name: "setRedeemVerify",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "allowRepayBorrow_",
                type: "bool",
            },
        ],
        name: "setRepayBorrowAllowed",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "allowSeize_",
                type: "bool",
            },
        ],
        name: "setSeizeAllowed",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "allowTransfer_",
                type: "bool",
            },
        ],
        name: "setTransferAllowed",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_src",
                type: "address",
            },
            {
                internalType: "address",
                name: "_dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_transferTokens",
                type: "uint256",
            },
        ],
        name: "transferAllowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class BoolTectonicCoreFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BoolTectonicCoreFactory = BoolTectonicCoreFactory;
BoolTectonicCoreFactory.bytecode = _bytecode;
BoolTectonicCoreFactory.abi = _abi;
//# sourceMappingURL=BoolTectonicCoreFactory.js.map